// Inline notice for a failed DataContext attendance load (userEventsError): the RSVP controls
// beside it are hidden or stale, so the error is shown with a Retry instead of reading as
// "not going" (W1: a query error is never shown as an empty result).
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useData } from "../../context/DataContext";
import { Button } from "../primitives";

export default function AttendanceNotice({ testId = "attendanceNotice" }) {
  const { userEventsError, userEventsLoaded, loadUserEvents } = useData();
  const [retrying, setRetrying] = useState(false);
  const aliveRef = useRef(true);
  useEffect(() => {
    aliveRef.current = true;
    return () => { aliveRef.current = false; };
  }, []);

  const retry = useCallback(async () => {
    if (retrying) return;
    setRetrying(true);
    try {
      await loadUserEvents();
    } finally {
      if (aliveRef.current) setRetrying(false);
    }
  }, [retrying, loadUserEvents]);

  if (!userEventsError) return null;
  return (
    <div className="row" role="alert" style={{ gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
      <span className="err-text grow">
        {userEventsLoaded ? "Couldn't refresh your RSVPs. What you see may be out of date." : "Couldn't load your RSVPs, so RSVP buttons are hidden."}
      </span>
      <Button size="sm" variant="sec" icon="refresh" onClick={retry} disabled={retrying} data-testid={`${testId}.retry`}>
        {retrying ? "Retrying…" : "Retry"}
      </Button>
    </div>
  );
}
